import './index.scss';

import * as Lightgallery from '../assets-base/assets-src/js/Spinao/Lightgallery';
import * as OffcanvasMenu from '../assets-base/assets-src/js/Spinao/OffcanvasMenu';
//import * as StickyTopMenu from '../assets-base/assets-src/js/Spinao/StickyTopMenu';
import '../assets-base/assets-src/js/Bootstrap/dropdown';
import Collapse from '../assets-base/assets-src/js/Bootstrap/collapse';
//import '../assets-base/assets-src/js/Bootstrap/alert';
//import '../assets-base/assets-src/js/Bootstrap/button';
import '../assets-base/assets-src/js/Bootstrap/carousel';
//import '../assets-base/assets-src/js/Bootstrap/modal';
//import '../assets-base/assets-src/js/Bootstrap/offcanvas';
//import '../assets-base/assets-src/js/Bootstrap/popover';
//import '../assets-base/assets-src/js/Bootstrap/scrollspy';
import '../assets-base/assets-src/js/Bootstrap/tab';
import '../assets-base/assets-src/js/Spinao/TabWithHistory';
//import '../assets-base/assets-src/js/Bootstrap/toast';
//import '../assets-base/assets-src/js/Bootstrap/tooltip';
import * as UnifyHeight from '../assets-base/assets-src/js/Spinao/UnifyHeight';
//import * as GoogleMaps from '../assets-base/assets-src/js/Spinao/GoogleMaps';
import * as NetteAjaxForm from '../assets-base/assets-src/js/Spinao/NetteAjaxForm';
import * as NetteAjaxLink from '../assets-base/assets-src/js/Spinao/NetteAjaxLink';
import * as EndlessList from '../assets-base/assets-src/js/Spinao/EndlessList';
import * as PlusMinusBtn from '../assets-base/assets-src/js/Spinao/PlusMinusBtn';
import * as RadioLikeCheckboxes from '../assets-base/assets-src/js/Spinao/RadioLikeCheckboxes';
import * as TextareaLengthIndicator from '../assets-base/assets-src/js/Spinao/TextareaLengthIndicator';
import * as CheckboxCombinations from '../assets-base/assets-src/js/Spinao/CheckboxCombinations';
import * as FormPersister from '../assets-base/assets-src/js/Spinao/FormPersister';
import * as AnimatedAnchor from '../assets-base/assets-src/js/Spinao/AnimatedAnchors';
import * as AttributeSetter from '../assets-base/assets-src/js/Spinao/AttributeSetter';
import * as Ares from '../assets-base/assets-src/js/Spinao/Ares';
import '../assets-base/assets-src/js/Spinao/GoogleReCaptcha';
//import '../assets-base/assets-src/js/Spinao/Basket';
import '../assets-base/assets-src/js/Spinao/DelegateClick';
import "../assets-base/assets-src/js/Spinao/CookieConsent";
import '../assets-base/assets-src/js/Spinao/Masonry';
import '../assets-base/assets-src/js/Spinao/Balikovna';
import '../assets-base/assets-src/js/Spinao/Ppl';
import '../assets-base/assets-src/js/Spinao/DatePicker';
import * as SpareParts from './spareParts';
import * as SparePartsCzech from './sparePartsCzech';
import * as BasketSwitch from './basketSwitch';

declare global {
    interface Window {
        b2bListRefresh: () => void;
        b2bDemandClear: () => void;
    }
}

type DemandItem = { id: string, label: string };

const DEMAND_STORAGE_KEY = 'b2bDemand';

/**
 * Galerie se váže na jednotlivé prvky, ne delegovaně, takže po překreslení
 * výpisu (filtr, hledání, SHOW MORE) mají nové řádky mrtvou fotku. Init je
 * proto idempotentní — hotové prvky si nese značka a podruhé se nezpracují,
 * jinak by na nich visely dvě galerie naráz.
 */
function initLightgallery(): void {
    Lightgallery.applyTo('[data-lightgallery="area"]:not([data-lightgallery-ready])', {
        selector: '[data-lightgallery="image"]',
        fullScreen: false,
        zoom: false,
        hash: false,
        pager: false
    });

    document.querySelectorAll('[data-lightgallery="area"]').forEach(function (area) {
        area.setAttribute('data-lightgallery-ready', '');
    });
}

/**
 * B2B poptávka: výběr strojů žije v localStorage, server o něm neví.
 *
 * Držet ho na klientu znamená, že se stav po každém překreslení výpisu musí
 * dopočítat znovu — tlačítka se renderují vždy ve výchozí podobě. Vlastní
 * NetteAjax po vykreslení snippetu nic nevyvolá, ale skripty uvnitř snippetu
 * spouští, takže si `window.b2bListRefresh` zavolá sám výpis (vehicle-list.latte).
 */
function demandRead(): DemandItem[] {
    try {
        let raw = window.localStorage.getItem(DEMAND_STORAGE_KEY);
        let parsed = raw === null ? [] : JSON.parse(raw);

        // pole (ne objekt) drží pořadí přidání i u číselných id; cokoli jiného je cizí zápis
        return Array.isArray(parsed)
            ? parsed.filter(function (item) {
                return item !== null && typeof item === 'object'
                    && typeof item.id === 'string' && typeof item.label === 'string';
            })
            : [];
    } catch (e) {
        return []; // privátní režim nebo rozbitý zápis — výběr prostě není
    }
}

function demandWrite(items: DemandItem[]): void {
    try {
        window.localStorage.setItem(DEMAND_STORAGE_KEY, JSON.stringify(items));
    } catch (e) {
        // zaplněná kvóta ani zakázané úložiště nesmí shodit klikání
    }
}

/**
 * Přepíše stav všech tlačítek podle výběru, naplní seznam ve formuláři a
 * podle toho, jestli je něco vybráno, formulář rozbalí nebo sbalí.
 */
function demandSync(): void {
    let items = demandRead();
    let ids = items.map(function (item) {
        return item.id;
    });

    document.querySelectorAll('.b2b-demand-add').forEach(function (btn) {
        if (!(btn instanceof HTMLButtonElement)) {
            return;
        }

        let selected = ids.indexOf(btn.dataset.demandId ?? '') !== -1;
        btn.classList.toggle('is-selected', selected);
        btn.classList.toggle('btn-dark', selected);
        btn.classList.toggle('btn-basesp', !selected);
        btn.textContent = selected
            ? (btn.dataset.demandLabelRemove ?? '')
            : (btn.dataset.demandLabelAdd ?? '');
    });

    let list = document.querySelector('[data-demand-list]');
    let collapse = document.querySelector('#b2bDemandFormCollapse');

    // po úspěšném odeslání je místo formuláře poděkování — tlačítka už stav mají,
    // collapse musí zůstat rozbalený, aby bylo poděkování vidět
    if (!(list instanceof HTMLTextAreaElement) || !(collapse instanceof HTMLElement)) {
        return;
    }

    list.value = items.map(function (item) {
        return item.label;
    }).join('\n');

    // default config toggluje hned v konstruktoru — vždy předávat toggle: false
    if (items.length > 0) {
        Collapse.getOrCreateInstance(collapse, {toggle: false}).show();
        // pole roste s obsahem, ať jsou vybrané stroje vidět (i zalomené řádky na mobilu);
        // scrollHeight jde měřit až po show() — zavřený collapse je display:none
        list.style.height = 'auto';
        list.style.height = (list.scrollHeight + 2) + 'px';
    } else {
        Collapse.getOrCreateInstance(collapse, {toggle: false}).hide();
        list.style.height = ''; // zpět na výchozí rows
    }
}

window.b2bListRefresh = function () {
    demandSync();
    initLightgallery();
};

// Po úspěšném odeslání poptávky (volá inline script v demand-form.latte).
// Collapse se nezavírá — uživatel musí vidět poděkování.
window.b2bDemandClear = function () {
    demandWrite([]);
    demandSync();
};

// Delegovaně na dokumentu: donačtené i překreslené řádky výpisu tak fungují
// bez opětovného navěšování
document.addEventListener('click', function (event) {
    let target = event.target;

    if (!(target instanceof Element)) {
        return;
    }

    let btn = target.closest('.b2b-demand-add');

    if (!(btn instanceof HTMLButtonElement)) {
        return;
    }

    let id = btn.dataset.demandId ?? '';
    let label = btn.dataset.demandItem ?? '';

    if (id === '' || label === '') {
        return;
    }

    let items = demandRead();
    let without = items.filter(function (item) {
        return item.id !== id;
    });

    demandWrite(without.length === items.length ? items.concat([{id: id, label: label}]) : without);
    demandSync();
});

document.addEventListener("DOMContentLoaded", function() {
    initLightgallery();
    demandSync();

    AnimatedAnchor.run();
    CheckboxCombinations.initialize();
    RadioLikeCheckboxes.initialize();
    TextareaLengthIndicator.initialize();
    PlusMinusBtn.initialize();
    FormPersister.initialize();

    OffcanvasMenu.initialize();
    //StickyTopMenu.initialize();

    SpareParts.initialize();
    SparePartsCzech.initialize();
    BasketSwitch.initialize();

    NetteAjaxForm.initialize('form[data-ajax]');
    NetteAjaxLink.applyTo('a[data-ajax]');

    //GoogleMaps.initialize();


    UnifyHeight.applyDataAttribute();
    EndlessList.applyTo('[data-endless-list]');
    AttributeSetter.run();
    Ares.run();

    // B2B kontakty: hned při kliku sjet na formulář — collapse je v tu chvíli ještě
    // display:none (nulový rect), proto se cílí na jeho col wrapper; po dojetí animace
    // pozici dorovná shown handler níže
    document.querySelectorAll('.b2b-contact-collapse').forEach(function (form) {
        if (!(form instanceof HTMLElement)) {
            return;
        }
        form.addEventListener('show.bs.collapse', function () {
            let target = form.parentElement instanceof HTMLElement ? form.parentElement : form;
            let nav = document.querySelector('nav');
            target.style.scrollMarginTop = (nav !== null ? nav.clientHeight * 1.5 : 0) + 'px';
            target.scrollIntoView({block: 'start', behavior: 'smooth'});
        });

        // po rozbalení doscrollovat jen minimálně — když je vidět začátek, dorovnat jen spodek;
        // na začátek najet jen když je celý pod obrazovkou (řeší i posun pozic při přepnutí akordeonu)
        form.addEventListener('shown.bs.collapse', function () {
            let rect = form.getBoundingClientRect();
            if (rect.top >= 0 && rect.bottom <= window.innerHeight) {
                return; // celý formulář je ve viewportu, nikam nejezdit
            }
            if (rect.height > window.innerHeight) {
                // vyšší než obrazovka — celý se nevejde, najet na jeho začátek
                let nav = document.querySelector('nav');
                form.style.scrollMarginTop = (nav !== null ? nav.clientHeight * 1.5 : 0) + 'px';
                form.scrollIntoView({block: 'start', behavior: 'smooth'});
            } else {
                // vejde se — posunout jen o minimum, aby byl vidět spodek formuláře
                form.style.scrollMarginBottom = '20px';
                form.scrollIntoView({block: 'end', behavior: 'smooth'});
            }
        });
    });

    // B2B menu: klik na kotvový odkaz v otevřeném offcanvas menu zavře menu;
    // dropdown toggly (data-bs-toggle, href="#") menu zavírat nesmí
    document.querySelectorAll('.offcanvas-collapse a[href^="#"]:not([href="#"]):not([data-bs-toggle])').forEach(function (link) {
        link.addEventListener('click', function () {
            OffcanvasMenu.close();
        });
    });

    // B2B kontakty: klik na e-mail zkopíruje adresu do schránky
    document.querySelectorAll('[data-copy-email]').forEach(function (el) {
        if (!(el instanceof HTMLElement)) {
            return;
        }
        el.addEventListener('click', function () {
            let email = el.dataset.copyEmail ?? '';
            if (email === '') {
                return;
            }

            let showCopied = function () {
                let icon = el.querySelector('i');
                el.classList.add('is-copied');
                if (icon !== null) {
                    icon.className = 'fas fa-check';
                }
                setTimeout(function () {
                    el.classList.remove('is-copied');
                    if (icon !== null) {
                        icon.className = 'far fa-copy';
                    }
                }, 1500);
            };

            if (navigator.clipboard !== undefined) {
                navigator.clipboard.writeText(email).then(showCopied);
            } else {
                // fallback pro http dev prostředí bez Clipboard API
                let textarea = document.createElement('textarea');
                textarea.value = email;
                textarea.style.position = 'fixed';
                textarea.style.opacity = '0';
                document.body.appendChild(textarea);
                textarea.select();
                document.execCommand('copy');
                document.body.removeChild(textarea);
                showCopied();
            }
        });
    });

    // Datové inputy nezvoleného typu termínu se schovají a zároveň vypnou (`disabled`): schovaný
    // input s hodnotou pod `min` by prohlížeč při odeslání tiše zablokoval (invalid control není
    // focusable), disabled prvek nevaliduje ani neodesílá. Hodnota zůstává, aby po přepnutí zpět
    // seděla s tím, co si drží AirDatepicker — vymazání hodnoty by ho rozhodilo.
    let syncTermRows = function (): void {
        let allRows = document.querySelectorAll('tr.termRow') as NodeListOf<HTMLElement>;
        allRows.forEach(function (row) {
            let input = row.querySelector('input');
            if (input instanceof HTMLInputElement) {
                let inputsBlock = row.querySelector('.dateInputs') as HTMLElement|null;
                if (inputsBlock !== null) {
                    inputsBlock.style.display = input.checked ? 'block' : 'none';
                    inputsBlock.querySelectorAll('input[type="date"]').forEach(function (dateInput: Element) {
                        if (dateInput instanceof HTMLInputElement) {
                            dateInput.disabled = !input.checked;
                        }
                    });
                }
            }
        });
    };

    syncTermRows();

    document.addEventListener('click', function (e) {
        let target = e.target;

        if (target instanceof HTMLElement && target.closest('tr.termRow') instanceof HTMLElement) {
            syncTermRows();
        }
    });

	let modelInput = document.querySelector('select[name="model"]');
	if (modelInput !== null) {
		document.addEventListener('click', function(e) {
			let target = e.target;

			if (target instanceof HTMLElement && target.hasAttribute('data-select-model')) {
				let selectedModel = target.getAttribute('data-select-model');
				modelInput.querySelectorAll('option').forEach(function (option): void {
					option.selected = option.getAttribute('value').indexOf(selectedModel) >= 0;
				});
			}
		});
	}
});
